<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">我的作品</span>
      </div>
    </div>
    <div class="box1"
         v-if="tabIndex == 1">
      <div class="b1top">
        <div class="b1tl">
          <span @click="b1Index = 1"
                :style="b1Index == 1 ? 'color: #0B8586;' : ''">历史作品资源</span>
          <span @click="b1Index = 2"
                :style="b1Index == 2 ? 'color: #0B8586;' : ''">草稿箱（{{ draftNum }}）</span>
        </div>
        <div class="b1tr"
             @click="IsAddResources = true"
             style="cursor:pointer">
          <img src="../../assets/img/icon/jia2.png"
               alt="" />
          <span style="margin-right:0">新增</span>
        </div>
      </div>
      <div class="listbox">
        <table v-if="b1Index == 1">
          <thead>
            <tr>
              <th>资源名称</th>
              <th>资源明细</th>
              <th>预设价格</th>
              <th>操作</th>
              <th>审核状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>{{ item.title }}</td>
              <td>
                <span style="color:#0B8586; cursor: pointer;"
                      @click="toCourseDetails(item.id, 0)">查看（{{ item.resNumber }}）</span>
              </td>
              <td>{{ item.c_Price == 0 ? '免费' : item.c_Price }}</td>
              <td>
                <img style="margin-right:10px;cursor: pointer;"
                     src="../../assets/img/icon/bianji.png"
                     @click="toUpdataResources(item.id)"
                     alt="" />
                <img src="../../assets/img/icon/shanchu.png"
                     style="cursor: pointer;"
                     v-show="item.audit != 9"
                     @click="toDeleteResources(item.id)"
                     alt="" />
              </td>
              <td>
                <span v-show="item.audit == 0">未推送，待审核</span>
                <span v-show="item.audit == 9">审核通过，已发布</span>
                <span v-show="item.audit == -1">审核未通过</span>
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="5">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
        <table v-if="b1Index == 2">
          <thead>
            <tr>
              <th>资源题目</th>
              <th>资源明细</th>
              <th style="width:313px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>{{ item.title }}</td>
              <td>
                <span style="color:#0B8586; cursor: pointer"
                      @click="toCourseDetails(item.id, 4)">查看（{{ item.resNumber }}）</span>
              </td>
              <td>
                <div style="background:#C32424"
                     @click="toDeleteResources(item.id)"
                     class="b1btn">删除</div>
                <div style="background:#5590E8"
                     @click="toUpdataResources(item.id)"
                     class="b1btn">修改</div>
                <div style="background:#0B8586"
                     @click="toSubmitResources(item.id)"
                     class="b1btn">提交</div>
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="3">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  @page-change="pageChange"></pagination>
      <el-dialog :visible.sync="IsAddResources"
                 class="AddResources"
                 :show-close="false"
                 width="814px">
        <div class="addResTop">
          <span>资源标题</span>
          <input type="text"
                 v-model="resTitle"
                 placeholder="请输入资源标题" />
          <div>
            <span :style="resTitle.length > 30 ? 'color:red' : ''">{{ resTitle.length }}</span>
            <span>/</span>
            <span>30</span>
          </div>
        </div>
        <div class="addResTop2">
          <span>资源上传：</span>

          <webupload fileaccept=".mp4,.mp3,.pdf"
                     :Maxfileszie="1024"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="handleSuccess">
            <div>选择资源</div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：仅支持上传mp4、mp3、pdf格式的文件</span>
        </div>
        <!-- <div class="addResTop2">
          <span>预设价格：</span>
          <div class="jgbox">
            <input type="text">
          </div>
          <span style="color: #0B8586;margin-left:10px">注：此设定价格仅供参考价格仅供参考</span>
        </div> -->
        <div class="addResList">
          <div v-for="(item, index) in resInfoList"
               :key="index">
            <span>{{ item.name }}</span>
            <img style="margin:0 36px 0 10px"
                 @click="deleteRes(item.resId)"
                 src="../../assets/img/icon/shanchu.png"
                 alt="" />
          </div>
        </div>
        <div class="addResTop2">
          <span>简介文字描述：</span>
        </div>
        <div class="addResTop jianjie">
          <input type="text"
                 v-model="resJian"
                 placeholder="请输入文字描述" />
          <div>
            <span :style="resJian.length > 1000 ? 'color:red' : ''">{{ resJian.length }}</span>
            <span>/</span>
            <span>1000</span>
          </div>
        </div>
        <div class="addResTop"
             style="border-bottom:none">
          <div>
            <span style="margin-right:10px">作品意向价格：</span>
            <el-radio-group v-model="radio">
              <el-radio label="1">免费</el-radio>
              <el-radio label="2">付费</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="addResTop4"
             v-show="radio == 2">
          <el-radio-group v-model="radio2">
            <el-radio label="1">
              <span style="margin-right:6px">VIP包库价格：</span>
              <input type="text"
                     @focus="radio2 = '1'"
                     v-model="resprice1"
                     placeholder="请输入意向价格（例22.00元）" />
            </el-radio>
            <el-radio label="2">
              <span>独立定价价格：</span>
              <input type="text"
                     @focus="radio2 = '2'"
                     v-model="resprice2"
                     placeholder="请输入意向价格（例22.00元）" />
            </el-radio>
          </el-radio-group>
        </div>
        <div class="addResTop3">
          <span>注：以上各项均为必填项</span>
        </div>
        <div class="addResTop5">
          <div class="aRT4box"
               @click="submit(0)">提交资源</div>
          <div class="aRT4box"
               @click="submit(2)"
               style="background: #9EA2A2;">存草稿</div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="IsUpdataResources"
                 class="AddResources"
                 :show-close="false"
                 width="814px">
        <div class="addResTop">
          <span>资源标题</span>
          <input type="text"
                 v-model="updataForm.resTitle" />
          <div>
            <span :style="updataForm.resTitle.length > 30 ? 'color:red' : ''">{{ updataForm.resTitle.length }}</span>
            <span>/</span>
            <span>30</span>
          </div>
        </div>
        <div class="addResTop2">
          <span>资源上传：</span>
          <webupload fileaccept=".mp4,.mp3,.pdf"
                     :Maxfileszie="1024"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="upHandleSuccess">
            <div>选择资源</div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：仅支持上传mp4、mp3、pdf格式的文件</span>
        </div>
        <div class="addResList">
          <div v-for="(item, index) in updataForm.resInfoList"
               :key="index">
            <span>{{ item.res_Title }}</span>
            <img style="margin:0 36px 0 10px"
                 @click="upDeleteRes(item.id)"
                 src="../../assets/img/icon/shanchu.png"
                 alt="" />
          </div>
        </div>
        <div class="addResTop2">
          <span>简介文字描述：</span>
        </div>
        <div class="addResTop jianjie">
          <input type="text"
                 v-model="updataForm.resJian" />
          <div>
            <span :style="updataForm.resJian.length > 1000 ? 'color:red' : ''">{{ updataForm.resJian.length }}</span>
            <span>/</span>
            <span>1000</span>
          </div>
        </div>
        <div class="addResTop"
             style="border-bottom:0px">
          <div>
            <span style="margin-right:10px">作品意向价格：</span>
            <el-radio-group v-model="updataForm.radio">
              <el-radio label="1">免费</el-radio>
              <el-radio label="2">付费</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="addResTop4"
             v-show="updataForm.radio == 2">
          <el-radio-group v-model="updataForm.radio2">
            <el-radio label="1">
              <span style="margin-right:6px">VIP包库价格：</span>
              <input type="text"
                     @focus="
                                    updataForm.radio2 = '1';
                                    updataForm.resprice2 = '';
                                "
                     v-model="updataForm.resprice1"
                     placeholder="请输入意向价格（例22.00元）" />
            </el-radio>
            <el-radio label="2">
              <span>独立定价价格：</span>
              <input type="text"
                     @focus="
                                    updataForm.radio2 = '2';
                                    updataForm.resprice1 = '';
                                "
                     v-model="updataForm.resprice2"
                     placeholder="请输入意向价格（例22.00元）" />
            </el-radio>
          </el-radio-group>
        </div>
        <div class="addResTop3">
          <span>注：以上各项均为必填项</span>
        </div>
        <div class="addResTop5">
          <div class="aRT4box"
               @click="upSubmit()">提交修改</div>
          <div class="aRT4box"
               @click="IsUpdataResources = false"
               style="background: #9EA2A2;">取消</div>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="资源作品详情"
               :visible.sync="isCourseDetails"
               class="Courselist"
               width="856px">
      <el-table :data="gridData"
                border>
        <el-table-column property="res_Title"
                         label="资源名称"></el-table-column>
        <el-table-column label="资源类型"
                         width="150">
          <template slot-scope="scope">
            <span v-show="scope.row.res_Type == 1">图片</span>
            <span v-show="scope.row.res_Type == 2">视频</span>
            <span v-show="scope.row.res_Type == 3">音频</span>
            <span v-show="scope.row.res_Type == 4">PDF</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="150">
          <template slot-scope="scope">
            <img style="margin-right:10px;cursor: pointer;"
                 src="../../assets/img/icon/bofang.png"
                 @click="toShow(scope.row)"
                 alt="" />
            <img src="../../assets/img/icon/shanchu.png"
                 style="cursor: pointer;"
                 @click="deleteRow(scope.row.id)"
                 alt="" />
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pageCount2"
                  :limit="pageSize2"
                  :page="pageIndex2"
                  @page-change="pageChange2"></pagination>
    </el-dialog>
    <perview :prerurl="prerurl"
             :show="IsPreview"
             :width="'856px'"
             :title="previewtitle"
             @dialogData="closeDialog"
             :filetype="filetype"></perview>
  </div>
</template>
<script>
import webupload from '../../components/webupload/webupload.vue';
import Perview from '../../components/Preview/Preview-template.vue';
export default {
  name: 'uaWarks',
  components: {
    webupload,
    Perview
  },
  data () {
    return {
      storeName: '',
      tabIndex: 1,
      b1Index: 1,
      storeList: [],
      draftNum: 0,
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      IsAddResources: false,
      resTitle: '',
      resJian: '',
      radio: '1',
      radio2: '1',
      resprice1: '',
      resprice2: '',
      resInfoList: [],
      itemId: 0,
      audit: 0,
      gridData: [],
      isCourseDetails: false,
      pageCount2: 0,
      pageIndex2: 1,
      pageSize2: 8,
      IsUpdataResources: false,
      updataForm: {
        resTitle: '',
        resJian: '',
        radio: '1',
        radio2: '1',
        resprice1: '',
        resprice2: '',
        resInfoList: []
      },
      orgid: 0,
      prerurl: '',
      IsPreview: false,
      previewtitle: '',
      filetype: ''
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName');
    this.orgid = Number(localStorage.getItem('storeId'));
    this.GetMyStoreList();
    this.GetDraftNum();
  },
  watch: {
    b1Index: function () {
      this.GetMyStoreList();
      this.GetDraftNum();
    },
    radio2: function () {
      this.resprice1 = '';
      this.resprice2 = '';
    }
  },
  methods: {
    handleSuccess (response, file) {
      this.resInfoList.push({
        resId: response.resid,
        name: file.name
      });
    },
    upHandleSuccess (response, file) {
      this.httphelper
        .post('/api/EnterpriseApi/SaveCuResBinding', {
          resId: response.resid,
          itemId: this.itemId
        })
        .then(res2 => {
          if (res2.data.code == 200) {
            this.updataForm.resInfoList.push({
              id: response.resid,
              res_Title: file.name
            });
            this.GetMyStoreList();
            this.GetDraftNum();
            this.$message({
              type: 'success',
              message: '上传成功!'
            });
          }
        });
    },
    GetMyStoreList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetCourseApplyList', {
          type: 1,
          businesId: Number(localStorage.getItem('storeId')),
          itemId: 0,
          audit: this.b1Index == 1 ? 0 : 4,
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data;
            this.pageCount = res.data.totalcount;
          }
        });
    },
    GetDraftNum () {
      this.httphelper
        .post('/api/EnterpriseApi/GetCourseApplyList', {
          type: 1,
          businesId: Number(localStorage.getItem('storeId')),
          itemId: 0,
          audit: 4,
          page: this.pageIndex,
          limit: 99
        })
        .then(res => {
          if (res.data.code == 200) {
            this.draftNum = res.data.totalcount;
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList();
    },
    submit (type) {
      let pri = 0;
      let chargeType = 0;
      if (this.radio == 2) {
        if (this.resprice1 == '' && this.resprice2 == '') return this.$message.error('意向价格不能为空');
        if (this.resprice1 == '') {
          pri = this.resprice2;
          chargeType = 2;
        } else {
          pri = this.resprice1;
          chargeType = 1;
        }
      }
      if (this.resTitle == '') return this.$message.error('标题不能为空');
      if (this.resJian == '') return this.$message.error('简介不能为空');
      if (this.resInfoList.length == 0) return this.$message.error('请上传资源');
      let resInfoIdList = new Array();
      for (let i = 0; i < this.resInfoList.length; i++) {
        resInfoIdList.push({
          resId: this.resInfoList[i].resId
        });
      }
      this.httphelper
        .post('/api/EnterpriseApi/SaveCourseApply', {
          id: 0,
          userType: 1,
          orgId: Number(localStorage.getItem('storeId')),
          title: this.resTitle,
          audit: type,
          coverRid: 0,
          coverUrl: '',
          c_Intro: this.resJian,
          c_format: 0,
          isDel: false,
          chargeType: chargeType,
          c_Price: parseFloat(pri),
          resInfoList: resInfoIdList
        })
        .then(res => {
          if (res.data.code == 200) {
            if (type == 0) this.$message.success('提交成功');
            else if (type == 2) this.$message.success('存草稿成功');
            this.GetMyStoreList();
            this.GetDraftNum();
            this.resTitle = '';
            this.resJian = '';
            this.resprice1 = 0;
            this.resprice2 = 0;
            this.resInfoList = [];
            this.IsAddResources = false;
          }
        });
    },
    deleteRes (id) {
      for (let i = 0; i < this.resInfoList.length; i++) {
        if (this.resInfoList[i].resId == id) this.resInfoList.splice(i, 1);
      }
    },
    toCourseDetails (id, type) {
      this.itemId = id;
      this.audit = type;
      this.isCourseDetails = true;
      this.getDetailList();
    },
    getDetailList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetOrgResInfoList', {
          type: 1,
          businesId: Number(localStorage.getItem('storeId')),
          itemId: this.itemId,
          audit: this.audit,
          page: this.pageIndex2,
          limit: this.pageSize2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.gridData = res.data.data;
            this.pageCount2 = res.data.totalcount;
          }
        });
    },
    deleteRow (id) {
      this.httphelper
        .post('/api/EnterpriseApi/DelOrgResInfo', {
          resId: id,
          itemId: this.itemId
        })
        .then(res => {
          if (res.data.code == 200) {
            this.getDetailList();
            this.GetMyStoreList();
            this.GetDraftNum();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        });
    },
    pageChange2 (page) {
      if (page == this.pageIndex2) {
        return;
      }
      this.pageIndex2 = page;
      this.getDetailList();
    },
    toUpdataResources (id) {
      this.itemId = id;
      this.httphelper
        .post('/api/EnterpriseApi/GetCourseApplyInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.audit = res.data.data.audit;
            this.updataForm.resTitle = res.data.data.title;
            this.updataForm.resInfoList = res.data.data.resList;
            this.updataForm.resJian = res.data.data.c_Intro;
            this.IsUpdataResources = true;
            if (res.data.data.chargeType == 0) this.updataForm.radio = '1';
            else if (res.data.data.chargeType == 1) {
              this.updataForm.radio = '2';
              this.updataForm.radio2 = '1';
              this.updataForm.resprice1 = res.data.data.c_Price;
            } else if (res.data.data.chargeType == 2) {
              this.updataForm.radio = '2';
              this.updataForm.radio2 = '2';
              this.updataForm.resprice2 = res.data.data.c_Price;
            }
          }
        });
    },
    toDeleteResources (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.httphelper
            .post('api/EnterpriseApi/DelCourseApply', {
              id: id
            })
            .then(res => {
              if (res.data.code == 200) {
                this.GetMyStoreList();
                this.GetDraftNum();
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    upDeleteRes (id) {
      this.httphelper
        .post('/api/EnterpriseApi/DelOrgResInfo', {
          resId: id,
          itemId: this.itemId
        })
        .then(res => {
          if (res.data.code == 200) {
            for (let i = 0; i < this.updataForm.resInfoList.length; i++) {
              if (this.updataForm.resInfoList[i].id == id) this.updataForm.resInfoList.splice(i, 1);
            }
            this.GetMyStoreList();
            this.GetDraftNum();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        });
    },
    upSubmit () {
      let pri = 0;
      let chargeType = 0;
      if (this.updataForm.resTitle == '') return this.$message.error('标题不能为空');
      if (this.updataForm.resJian == '') return this.$message.error('简介不能为空');
      if (this.updataForm.radio == 2) {
        if (this.updataForm.resprice1 == '' && this.updataForm.resprice2 == '') return this.$message.error('意向价格不能为空');
        if (this.updataForm.resprice1 == '') {
          pri = this.updataForm.resprice2;
          chargeType = 2;
        } else {
          pri = this.updataForm.resprice1;
          chargeType = 1;
        }
      }
      this.httphelper
        .post('/api/EnterpriseApi/SaveCourseApply', {
          id: this.itemId,
          userType: 1,
          orgId: Number(localStorage.getItem('storeId')),
          title: this.updataForm.resTitle,
          audit: this.audit,
          coverRid: 0,
          coverUrl: '',
          c_Intro: this.updataForm.resJian,
          c_format: 0,
          isDel: false,
          chargeType: chargeType,
          c_Price: parseFloat(pri),
          resInfoList: []
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('提交成功');
            this.GetMyStoreList();
            this.GetDraftNum();
            this.updataForm.resTitle = '';
            this.updataForm.resJian = '';
            this.updataForm.resprice1 = 0;
            this.updataForm.resprice2 = 0;
            this.updataForm.resInfoList = [];
            this.IsUpdataResources = false;
          }
        });
    },
    toSubmitResources (id) {
      this.itemId = id;
      this.httphelper
        .post('/api/EnterpriseApi/GetCourseApplyInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.audit = res.data.data.audit;
            this.updataForm.resTitle = res.data.data.title;
            this.updataForm.resInfoList = res.data.data.resList;
            this.updataForm.resJian = res.data.data.c_Intro;
            if (res.data.data.chargeType == 0) this.updataForm.radio = '1';
            else if (res.data.data.chargeType == 1) {
              this.updataForm.radio = '2';
              this.updataForm.radio2 = '1';
              this.updataForm.resprice1 = res.data.data.c_Price;
            } else if (res.data.data.chargeType == 2) {
              this.updataForm.radio = '2';
              this.updataForm.radio2 = '2';
              this.updataForm.resprice2 = res.data.data.c_Price;
            }
            let pri = 0;
            let chargeType = 0;
            if (this.updataForm.radio == 2) {
              if (this.updataForm.resprice1 == '' && this.updataForm.resprice2 == '') return this.$message.error('意向价格不能为空');
              if (this.updataForm.resprice1 == '') {
                pri = this.updataForm.resprice2;
                chargeType = 2;
              } else {
                pri = this.updataForm.resprice1;
                chargeType = 1;
              }
            }
            this.httphelper
              .post('/api/EnterpriseApi/SaveCourseApply', {
                id: this.itemId,
                userType: 1,
                orgId: Number(localStorage.getItem('storeId')),
                title: this.updataForm.resTitle,
                audit: 0,
                coverRid: 0,
                coverUrl: '',
                c_Intro: this.updataForm.resJian,
                c_format: 0,
                isDel: false,
                chargeType: chargeType,
                c_Price: parseFloat(pri),
                resInfoList: []
              })
              .then(res => {
                if (res.data.code == 200) {
                  this.$message.success('提交成功');
                  this.GetMyStoreList();
                  this.GetDraftNum();
                  this.updataForm.resTitle = '';
                  this.updataForm.resJian = '';
                  this.updataForm.resprice1 = 0;
                  this.updataForm.resprice2 = 0;
                  this.updataForm.resInfoList = [];
                }
              });
          }
        });
    },
    toShow (item) {
      this.prerurl = item.resUrl;
      this.previewtitle = item.res_Title;
      this.filetype = item.res_File_Suffix;
      this.IsPreview = true;
    },
    closeDialog () {
      this.IsPreview = false;
    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.box1 {
    padding-top: 10px;
}
.b1top {
    margin: 20px 0;
    height: 18px;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.b1top span {
    margin-right: 40px;
    cursor: pointer;
}
.b1tr {
    display: flex;
    align-items: center;
}
.b1tr img {
    margin-right: 10px;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.b1btn {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
}
.b1fengmian {
    width: 65px;
    height: 45px;
}
.box2 {
    padding-top: 20px;
}
.AddResources ::v-deep .el-dialog__header {
    display: none;
}
.AddResources ::v-deep .el-dialog__body {
    padding: 35px 50px;
    box-sizing: border-box;
}
.addResTop {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
}
.addResTop input {
    flex: 1;
    margin: 0 10px;
    border: none;
    outline: none;
}
.addResTop2 {
    min-height: 30px;
    margin-top: 26px;
    display: flex;
    align-items: center;
}
.addResList {
    margin-top: 26px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.addResList div {
    display: flex;
    align-items: center;
    height: 30px;
}
.addResTop2 div {
    width: 175px;
    height: 30px;
    background: #0b8586;
    border-radius: 3px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}
.addResTop2 .jgbox {
    width: 173px;
    height: 28px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background-color: #fff;
    display: flex;
    align-items: center;
}
.addResTop2 input {
    width: 159px;
    height: 24px;
    border: none;
    outline: none;
    padding-left: 10px;
}
.jianjie input {
    margin-left: 0;
}
.addResTop3 {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    border-top: 1px solid #eee;
}
.addResTop5 {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}
.aRT4box {
    width: 148px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    margin: 0 5px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.addResTop ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #0b8586 !important;
}
.addResTop ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background: #0b8586 !important;
    border-color: #0b8586 !important;
}
.addResTop4 {
    margin-left: 110px;
    padding-top: 7px;
}
.addResTop4 ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background: #0b8586 !important;
    border-color: #0b8586 !important;
}
.addResTop4 ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #606266 !important;
}
.addResTop4 ::v-deep .el-radio-group {
    display: flex;
    flex-direction: column;
}
.addResTop4 ::v-deep .el-radio {
    height: 36px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.addResTop4 input {
    width: 384px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    outline: none;
    padding-left: 10px;
}
.Courselist ::v-deep .el-dialog {
    padding: 50px 59px;
}
.Courselist ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.Courselist ::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: 30px;
}
.Courselist ::v-deep .el-dialog__body {
    padding: 0;
}
.Courselist ::v-deep .cell {
    text-align: center;
}
.Courselist ::v-deep .el-button {
    height: 21px;
    padding: 4px;
}
.Courselist ::v-deep td,
.Courselist ::v-deep th {
    padding: 8px 0 !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.Courselist ::v-deep th {
    background: #edfafa;
}
.pagination_Wrap {
    margin-bottom: 0;
}
</style>
